import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const WeddingIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M29.7906 26.0675C31.1584 28.084 31.9518 30.5281 31.9518 33.1673C31.9518 40.0813 26.4531 45.6849 19.6688 45.6849C12.8844 45.6849 7.3858 40.0813 7.3858 33.1673C7.3858 26.2533 12.8844 20.6497 19.6688 20.6497C22.45 20.6497 25.0215 21.5975 27.0823 23.1866" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M27.4289 40.4437C27.365 40.3508 27.3012 40.2578 27.2374 40.1649C25.9151 38.1669 25.14 35.76 25.14 33.1673C25.14 26.2533 30.6387 20.6497 37.423 20.6497C44.2074 20.6497 49.706 26.2533 49.706 33.1673C49.706 40.0813 44.2074 45.6849 37.423 45.6849C34.66 45.6849 32.1159 44.7556 30.0642 43.1944" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.4022 9.73901H19.6778H16.9534L14.2156 13.4546L16.9534 18.6265H22.4022L25.14 13.4546L22.4022 9.73901Z" fill={props.htmlColor || "#FFCB06"} stroke={props.htmlColor || "#FFCB06"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
};

export default WeddingIcon;
